const INFO = {
	main: {
		title: "Simon Sammel-Krawa",
		name: "Simon SK",
		email: "bsimonsammel@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		// twitter: "https://twitter.com/",
		github: "https://github.com/bssammel",
		linkedin: "https://www.linkedin.com/in/simon-sammel/",
		leetcode: "https://leetcode.com/u/bssammel/",
		hackerRank: "https://www.hackerrank.com/profile/bssammel"
		// instagram: "https://instagram.com/",
		// stackoverflow: "https://stackoverflow.com/",
		// facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full stack software engineer, enthusiastic debugger, and outdoor hobbyist",
		description:
			"With on the job experience in back end development and personal project experience designing intuitive front ends, I am passionate about leveraging my skills to help people grow - however that takes its form. Whether that work is in healthcare, agriculture, education or another technical industry, I am more than eager to spend my days puzzle solving and debugging.",
	},

	about: {
		title: "My passion for engineering has its roots in ecology.",
		newTechs: "the Socket.io web-socket library and TypeScript",
		description:
			["When originally pursuing a degree in biology, I was deciding what Master's I wanted to pursue and was intimidated by the Python requirement in my preferred program. My partner then -now spouse- encouraged me to apply to an internship where he currently worked. That internship quickly shifted my passion for insect and disease \"bugs\", to a passion for software bugs.", "In my garden or at my desk, I am not afraid to get a bit dirty. Digging deep and learning about the greater systems that impact individual components and elements, helps me to build a fuller picture and effectively plan long term for more maintainable code.", "When I am not at my desk, you can likely find me cooking with my husband, spending weekends on trails with my lab mix, and sitting in my garden admiring whatever heirloom crop I have growing at the moment. (Please ask me about my pea varieties).", "When my husband and I got married, we both talked about growing in our vows and it is not just a value in our marriage, but one that we apply to our careers and relationships with other loved ones. I have found software engineering to be so fulfilling in part due to the constant need for growth and transformation. A career to always learn in is never a dull one. I am currently working on expanding my skill set to include the Socket.io web-socket library and TypeScript.","In my pursuit of continual growth, I have found that new skills are not the only way to grow, but correcting poor growth is just as valuable. As a recovering perfectionist, taking the time to clear my head has wildly improved my productivity and code quality. A break to either make a quick chai latte or spending a moment weeding my garden can be the best way to clear my head and readdress whatever problem or feature is currently on my plate. It has been satisfying to find ways to manage and control that obsession for flawlessness, but still maintain the drive that led to it and ultimately reach the goal I orginally had in mind."],
		
	},

	// articles: {
	// 	title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
	// 	description:
	// 		"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	// },

	projects: [
		{
			title: "Akeso EMR/EHR",
			description:
				"Akeso is a PERN stack EMR designed specifically for Direct Primary Care practices. I am currently working on tweaks to improve front end conditional view logic before working on the second major release to introduce appointment creation, encounter creation, and vitals tracking. Release planned for end of June 2024 but timeline is flexible due to relocating.",
			logo: "../akeso-logo.png",
			linkText: "View Live Site",
			link: "https://akeso-emr.onrender.com/",
		},

		{
			title: "The Paw",
			description:
				"Built with a Python backend, this website is designed to allow pet owners to easily find businesses friendly to and made for their pets. Built alongside two other talented engineers. Be sure to check their links out as well in the footer!",
			logo: "../the-paw-logo.png",
			linkText: "View Live Site",
			link: "https://the-paw.onrender.com/",
		},

		{
			title: "Homegrown",
			description:
				"Modeled after nightly rental platforms, this application hopes to address one of the struggles many urban gardeners face - a lack of space. Currently not live due to migrating between platforms. Next major release aimed for early autumn 2024 to be a full revamp as this was my first major project. My skills have advanced considerably since the inital build, and this project is a demonstration of that. Built with a PERN stack.",
			logo: "../homegrown-logo.png",
			linkText: `View Repository`,
			link: "https://github.com/bssammel/homegrown",
			// add separate github and live site links longterm
		},

		// {
		// 	title: "Project 4",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// },

		// {
		// 	title: "Project 5",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// },
	],
};

export default INFO;
